import badgePng from '../../../../assets/jackpot/widget-crown-badge.png';
import badgeWebp from '../../../../assets/jackpot/widget-crown-badge_2x.webp';
import jpLabelPng from '../../../../assets/jackpot/widget-crown-jp-label.png';
import jpLabelWebp from '../../../../assets/jackpot/widget-crown-jp-label_2x.webp';
import wordmarkPng from '../../../../assets/jackpot/widget-wordmark.png';
import wordmarkWebp from '../../../../assets/jackpot/widget-wordmark_2x.webp';

import styles from './JackpotWidgetArt.module.scss';

/**
 * Crown Jackpot widget artwork (KRA-303), exported from the Figma "Features 2 (2026)" file — frames
 * `17654:64648` (wide) and `17654:64942` (small).
 *
 * Replaces the placeholder `<Crown />` SVG both widgets used to draw. A 1x PNG fallback plus a 2x
 * WebP source, and every image declares its render size as attributes so the rail reserves the right
 * box before the image decodes rather than reflowing when it lands.
 *
 * The two wordmarks are baked rather than styled text: both are gold gradient fills with a stroke
 * and an inset highlight, they are logotypes so they are never translated, and CSS would only
 * approximate them. Their `alt` still carries the translated string so they read correctly aloud.
 */
interface ArtProps {
  className?: string;
  alt?: string;
}

/** Circular crown badge — 66x67 in the wide widget, reused at the small widget's own size. */
export function WidgetCrownBadge({ className, alt = '' }: ArtProps) {
  return (
    <picture className={`${styles.art} ${className ?? ''}`}>
      <source srcSet={badgeWebp} type="image/webp" />
      <img alt={alt} height={67} src={badgePng} width={66} />
    </picture>
  );
}

/** `CROWN JACKPOT` wordmark above the amount pill on the wide widget (106x11). */
export function WidgetWordmark({ className, alt = '' }: ArtProps) {
  return (
    <picture className={`${styles.art} ${className ?? ''}`}>
      <source srcSet={wordmarkWebp} type="image/webp" />
      <img alt={alt} height={11} src={wordmarkPng} width={106} />
    </picture>
  );
}

/** `CROWN JP` ribbon across the small widget's badge (60x14). */
export function WidgetCrownJpLabel({ className, alt = '' }: ArtProps) {
  return (
    <picture className={`${styles.art} ${className ?? ''}`}>
      <source srcSet={jpLabelWebp} type="image/webp" />
      <img alt={alt} height={14} src={jpLabelPng} width={60} />
    </picture>
  );
}
